import { AiPageProvider } from "../../context/AiPageContext";
import ServicePageLayout from "./ServicePageLayout";

export default function Ai() {
  return (
    <AiPageProvider>
      <ServicePageLayout />
    </AiPageProvider>
  );
}
